import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HttpErrorHandlerContribution } from '@patsnap/tahiti-core/common/http-error-handler-contribution';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
import { PsHttp$, PsHttpChannel, PsHttpChannelImpl } from '@patsnap/tahiti-core/common/http-channel';
import { Message } from '@patsnap/tahiti-core/common/message';
import { Toast } from 'patsnap-biz';
import { OpenService, OpenServiceImpl } from '@analytics/shared/services/open-service';
import { QueueService, QueueServiceImpl } from '@/services/queue-service';
import { Symbols } from '@/constants';
import { i18n } from '@/utils/i18n-instance';
import { CustomHighlightService, CustomHighlightServiceImpl } from '@/services/common/custom-highlight';
import { CheckSensitiveWordService, CheckSensitiveWordServiceImpl } from '@/services/common/check-sensitive-word';
import { I18nService } from '@analytics/shared/services/i18n.interface';
import { VueRouterService } from '@analytics/shared/services/vue-router-service.interface';
import { router } from '@/routers';

export const baseModule = new ContainerModule((bind) => {
    bindContributionProvider(bind, HttpErrorHandlerContribution);
    bind(PsHttp).toConstantValue(psHttp);
    bind(PsHttp$).toConstantValue(psHttp$);
    bind(PsHttpChannel).to(PsHttpChannelImpl);
    bind(Message).toConstantValue(Toast);
    bind(Symbols.VueI18n).toConstantValue(i18n);
    bind(I18nService).toConstantValue(i18n);
    bind(OpenService).to(OpenServiceImpl);
    bind(QueueService).to(QueueServiceImpl).inRequestScope();
    bind(CustomHighlightService).to(CustomHighlightServiceImpl);
    bind(CheckSensitiveWordService).to(CheckSensitiveWordServiceImpl);
    bind(VueRouterService).toConstantValue(router);
});
